import React from 'react'
import PropTypes from 'prop-types'
import { AddMemberInvoiceForm } from '../../shared/components'

const AddMemberInvoiceComponent = ({ onSubmit, memberId }) => (
  <AddMemberInvoiceForm
    header="Add member invoice"
    onSubmit={onSubmit}
    memberId={memberId}
  />
)

AddMemberInvoiceComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  memberId: PropTypes.func.isRequired,
}

export default AddMemberInvoiceComponent
